import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import PaginationNav from "./PaginationNav";
import { useSelector } from "react-redux";
import {
  selectQueryParams,
} from "../ui/customerListingReducer";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

const TabularListingHeader = (props) => {
  const [searchText, setSearchText] = useState(useSelector(selectQueryParams)["search"]);
  const searchBy = props.searchBy;
  const queryParams = useSelector(selectQueryParams);

  const onSearchInputChange = (e) => {
    e.preventDefault();
    setSearchText(e.target.value);
  };

  const onSearch = (e) => {
    if (e.type === "keydown" && e.keyCode === 13) {
      props.onSearch(e, searchText);
    } else if (e.type !== "keydown") {
      e.preventDefault();
      props.onSearch(e, searchText);
    }
  };

  const onPerPageChange = (e) => {
    e.preventDefault();
    if (e.target.value !== "") {
      props.onPerPageChange(e, parseInt(e.target.value));
    }
  };

  const onPageChange = (e) => {
    e.preventDefault();
    if (e.target.value !== "") {
      props.onPageChange(e, parseInt(e.target.value));
    }
  };
  return (
    <div className="tabular-listing-header">
      <Row className="pt-2">
        <Col>
          <div className="d-flex">
            <select
              value={queryParams.per_page}
              className="form-select me-2"
              onChange={onPerPageChange}
            >
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>200</option>
              <option>500</option>
            </select>
            <input
              type="number"
              className="form-control me-2 goto-page"
              style={{ width: "50px", height: "35px" }}
              onKeyDown={(e) => e.key === "Enter" && onPageChange(e)}
            />
            <PaginationNav
              paginationMeta={props.paginationMeta}
              onPageChange={props.onPageChange}
              className="pagination-nav"
            />
          </div>
        </Col>
        <Col>
          <div className="search-and-filter-container">
            {props.tableHeaderActionsComponent}
            {!!!props.hideSearch && <span style={{ position: "relative" }} className="me-2">
              <input
                value={searchText || ""}
                className="s-round-input"
                placeholder="Search"
                onChange={onSearchInputChange}
                onKeyDown={onSearch}
              />
              <span
                className="me-2"
                style={{
                  position: 'absolute',
                  top: "50%",
                  right: "7px",
                  transform: "translateY(-50%)",
                }}
              >
                <FontAwesomeIcon
                  className="icon"
                  icon={faMagnifyingGlass}
                  onClick={onSearch}
                />
                {searchBy &&
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={(props) =>
                      <Tooltip id="search-ifo-tooltip" {...props} style={{ ...props.style, fontSize: "11px" }}>
                        <strong>Search By</strong>
                        {searchBy.map((values) => <div key={values}>{values}</div>)}
                      </Tooltip>}
                  >
                    <FontAwesomeIcon
                      className="icon ms-2"
                      icon={faInfoCircle}
                      style={{ cursor: 'pointer', color: 'green' }}
                    />
                  </OverlayTrigger>
                }
              </span>
            </span>}
            {props.filters}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TabularListingHeader;
